import { TextArea, Box } from '@usealloy/component-library';
import styled from 'styled-components';

export const MatrixOptionsContainer = styled(Box)`
  &&& {
    align-items: flex-start;
    justify-content: space-between;
    overflow-x: auto;
    padding: var(--cl-space-5) var(--cl-space-6);
    gap: var(--cl-space-4);
  }
`;

export const StyledLeftColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 47%;
  gap: var(--cl-space-4);
`;

export const StyledRightColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 48%;
  gap: var(--cl-space-4);
`;

export const StyledTextArea = styled(TextArea)`
  &&& {
    resize: vertical;
  }
`;
